import { render, staticRenderFns } from "./CoursesTimetable.vue?vue&type=template&id=609f457b"
import script from "./CoursesTimetable.vue?vue&type=script&lang=js"
export * from "./CoursesTimetable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports